function getEmailCampaignValueFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('email-campaign');
}

function setCookie(name, value, expiration) {
    const expires = `expires=${expiration.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

function getCookie(name) {
    const cookieValue = document.cookie.split(';')
      .map(cookie => cookie.trim())
      .find(cookie => cookie.startsWith(`${name}=`));
    if (cookieValue) {
      return cookieValue.split('=')[1];
    } else {
      return null;
    }
}  

function createAnnouncement() {
    const body = document.body;
    const div = document.createElement("div");

    div.innerText = "BUY ONE GET ONE 50% OFF — USE CODE Madness";
    div.classList.add("js-announcement")
    body.prepend(div);
}
  
const isEmailCampaign = getEmailCampaignValueFromUrl();


if (isEmailCampaign == "true") {
    console.log("setted the cookie")
    console.log(isEmailCampaign)
    const expirationDate = new Date('April 3, 2023 23:59:00 EST');
    setCookie('email-campaign', 'true', expirationDate);
}

const emailCampaignValue = getCookie('email-campaign');

if (emailCampaignValue == "true") {
    createAnnouncement()
}